import { Share } from '@phosphor-icons/react/dist/ssr';
import classnames from 'classnames';
import { Suspense, forwardRef } from 'react';

import { DropdownMenu, UnstyledDropdownMenuContent, UnstyledDropdownMenuTrigger } from '@/ui/DropdownMenu';
import { PlatformShareButton } from '@/ui/PlatformShareButton';
import * as styles from '../PostActions.css';

interface Props {
  title: string;
  description: string;
  url: string;
}

const PLATFORMS = ['email', 'x', 'linkedIn', 'meta', 'reddit', 'whatsApp'];

export const ShareDropdown = forwardRef<HTMLButtonElement, Props>(({ title, description, url, ...props }, ref) => {
  return (
    <Suspense>
      <DropdownMenu>
        <UnstyledDropdownMenuTrigger ref={ref} className={classnames('flex justify-center', styles.button)} {...props}>
          <Share size="20" />
        </UnstyledDropdownMenuTrigger>
        <UnstyledDropdownMenuContent
          style={{
            minWidth: 'initial',
          }}
          side="top"
          className="grid grid-cols-2 gap-0 overflow-hidden shadow-md rounded-md"
        >
          {PLATFORMS.map((platform) => (
            <PlatformShareButton
              key={platform}
              className={classnames(styles.socialShareButton)}
              title={title}
              url={url}
              platform={platform}
            />
          ))}
        </UnstyledDropdownMenuContent>
      </DropdownMenu>
    </Suspense>
  );
});
